import axios from 'axios';
import base from '@/__vue2stone/service/wasaapi/v1/__base';
import store from '@/store';
import S_base from '@/service/api/v1/__base';

export default {
  async getUser() {
    // get auth
    return new Promise((resolve, reject) => {
      axios
        .get(`/auth/user`)
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async authUpdate(data) {
    const res = await base.update({
      url: 'auth/user',
      data: data,
    });
    return res;
  },
  async createUser(data) {
    const factoryId = store.state.app.factoryId;
    const res = await S_base.create({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'user',
      data: data,
    });
    return res;
  },
  async organizationCreateUser(data) {
    const currentOrganization = store.state.app.organization;
    const _data = {
      organization: currentOrganization.id,
      ...data,
    };
    const res = await base.create({
      url: 'organization/user/create',
      data: _data,
    });
    return res;
  },
  async showUser(userId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await S_base.show({
      modelName: 'user',
      modelId: userId,
      params: _params,
    });
    return res;
  },
  async showOrganizationUser(userId, params) {
    const res = await S_base.show({
      modelName: 'organization/user',
      modelId: userId,
      params: params,
    });
    return res;
  },
  async factoryIndex(factoryId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'factory_index',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async organizationIndex(params) {
    const currentOrganization = store.state.app.organization;
    const _params = {
      organization: currentOrganization.id,
      ...params,
    };
    const res = await base.index({
      modelName: 'organization_index/user',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async temporaryPasswordCreate(data) {
    const _data = {
      factory: store.state.app.factoryId,
      organization: store.state.app.organizationId,
      ...data,
    };
    const res = await axios.post('temporary_password/request', _data);
    return res.data;
  },
  async disabled(factoryId, userId, data) {
    const res = await S_base.create({
      url: `factory/${factoryId}/user/${userId}/disabled`,
      data: data,
    });
    return res;
  },
  async delete(factoryId, userId) {
    const res = await S_base.delete({
      url: `factory/${factoryId}/user/${userId}`,
    });
    return res;
  },
  async organizationDisabled(organizationId, userId) {
    const data = {
      organization: organizationId,
    };
    const res = await S_base.create({
      url: `organization/user/${userId}/disabled`,
      data: data,
    });
    return res;
  },
  async organizationDelete(organizationId, userId) {
    const params = {
      organization: organizationId,
    };
    const res = await base.delete({
      url: `organization/user/${userId}`,
      params,
    });
    return res;
  },
  async verifyEmailRequest(data) {
    const res = await S_base.create({
      url: 'verifyemail/request',
      data: data,
    });
    return res;
  },
  async update(userId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'user',
      modelId: userId,
      data: _data,
    });
    return res;
  },
  async organizationUpdate(data) {
    const _data = {
      organization: store.state.app.organization.id,
      ...data,
    };
    const res = await base.create({
      url: 'organization/user/update',
      data: _data,
    });
    return res;
  },
  async forgetPasswordRequest(data) {
    const res = await base.create({
      url: 'auth/forgetpassword/request',
      data,
    });
    return res;
  },
  async changeUserName(memberId, data) {
    const res = await S_base.create({
      url: `change_user_name/${memberId}`,
      data: data,
    });
    return res;
  },
  async startUser(memberId, data) {
    const res = await S_base.create({
      url: `user/${memberId}/restart`,
      data: data,
    });
    return res;
  },
  async resendVerifyEmailRequest(id) {
    const res = await S_base.create({
      url: `user/${id}/verifyemail/resend`,
    });
    return res;
  },
  async batchUsersCreate(data) {
    const factoryId = store.state.app.factoryId;
    const res = await base.create({
      url: `factory/${factoryId}/user/batch/store`,
      data,
    });
    return res;
  },
  async forgetPasswordRequestNoCaptcha(data) {
    const res = await base.create({
      url: 'auth/forgetpassword/request/no_captcha',
      data,
    });
    return res;
  },
};
